import { AbstractFilter } from "../types/AbstractFilter"
import { FilterRequest } from "../types/request"

/**
 * Filter element restricting the product selection to a given list of product IDs.
 *
 * Must not be used in conjunction with ProductGroupFilter, CharacteristicFilter or BoolFilter, otherwise service responds with status code 400 (Bad Request).
 */
export class ProductsFilter implements AbstractFilter {
    private ids: string[]

    constructor() {
        this.ids = []
    }

    /**
     * IDs of products.
     * @param {string|string[]} _id - the id or ids
     * @return {this} - the instance of the ProductsFilter class
     */
    public id(_id: string | string[]): this {
        if (Array.isArray(_id)) {
            this.ids = [...this.ids, ..._id]
        } else {
            this.ids.push(_id)
        }

        return this
    }

    /**
     * Builds the ProductsFilter object.
     * @returns {object} - the ProductsFilter object
     */
    public build(): FilterRequest {
        return {
            productsFilter: {
                ids: this.ids
            }
        }
    }
}
